import client from 'App/apollo';
import { EventName } from '__generated__/globalTypes';
import { logException } from '../../logging';
import { LOG_EVENT_MUTATION } from './withLogEvent';
import { getSentAtTimestamp, updateInteractionSession } from '.';

export interface TrackServersideInput {
  eventName: EventName;
  eventProperties?: Record<string, unknown>;
  brazeProperties?: Record<string, unknown>;
}

export const trackServerside = async ({
  eventName,
  eventProperties,
  brazeProperties,
}: TrackServersideInput): Promise<void> => {
  try {
    updateInteractionSession();

    await client.mutate({
      mutation: LOG_EVENT_MUTATION,
      variables: {
        input: {
          eventName,
          eventProperties: {
            clientSentAtUtcTimestamp: getSentAtTimestamp(),
            ...eventProperties,
          },
          brazeProperties,
        },
      },
    });
  } catch (error) {
    logException(error);
  }
};
